import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { RepositoryBinding, RepositoryPipeline, RepositoryPipelines } from '../models/repository-binding.model';

@Injectable({ providedIn: 'root' })
export class RepositoryBindingService {
  private readonly http = inject(HttpClient);
  private readonly base = `${environment.apiBaseUrl}/api/v1/projects`;

  list(projectId: string): Observable<RepositoryBinding[]> {
    return this.http.get<RepositoryBinding[]>(`${this.base}/${projectId}/repositories`);
  }

  /**
   * Die Listenform ist die Antwort eines Backends vor NEX-1267. Frontend und Backend
   * werden getrennt ausgerollt, und ohne diese Toleranz zeigt die Karte in der Luecke
   * dazwischen weder Pipelines noch einen Hinweis (NEX-1268).
   */
  pipelines(projectId: string, repositoryId: string): Observable<RepositoryPipelines> {
    return this.http
      .get<
        RepositoryPipelines | RepositoryPipeline[]
      >(`${this.base}/${projectId}/repositories/${repositoryId}/pipelines`)
      .pipe(map((answer) => (Array.isArray(answer) ? { branch: null, pipelines: answer } : answer)));
  }
}
